import { Ability } from '@casl/ability';

export default {
  ability() {
    return new Ability([]);
  },
  isImpersonated: state => state.siteInfo && state.siteInfo.isImpersonated,
};
